import { computed, makeAutoObservable } from "mobx";
import { injectable } from "inversify";
import type { Session } from "next-auth";
import { IAuthStore, SessionStatus } from "@workspace/types";

@injectable()
export class AuthStore implements IAuthStore {
  session: Session | null = null;
  status: SessionStatus = "loading";

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setSession(session: Session | null, status: SessionStatus) {
    this.session = session;
    this.status = status;
  }

  clearSession() {
    this.session = null;
    this.status = "unauthenticated";
  }

  get isAuthenticated() {
    return this.status === "authenticated" && !!this.session;
  }

  get isLoading() {
    return this.status === "loading";
  }

  get user() {
    return this.session?.user;
  }

  get accessToken() {
    return this.session?.accessToken;
  }
}
